const setEggRollsIDEAvailable = payload => ({
  type: "SET_EGG_ROLL_SIDE_AVAILABLE",
  payload,
});

export default setEggRollsIDEAvailable;
